<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="mr-auto">
      <button mat-raised-button routerLink="/contractors" class="m-1 mr-2" id="back">
        <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
      </button>

      <mat-menu #linkMenu="matMenu">
        <button mat-menu-item (click)="onLinkSites()">Link {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}</button>
        <button mat-menu-item (click)="onLinkAllSites()" *ngIf="contractor.id">
          Link All {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
        </button>
        <button mat-menu-item (click)="onUnlinkAllSites()" *ngIf="contractor.id">
          Unlink All {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
        </button>
      </mat-menu>

      <button
        mat-raised-button
        color="primary"
        class="m-1 mr-2"
        [matMenuTriggerFor]="linkMenu">
        <mat-icon>link</mat-icon> Link
      </button>

      <mat-menu #appMenu="matMenu">
        <button mat-menu-item (click)="dataSource.selectAllToggle()">
          <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
          {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
        </button>
        <button mat-menu-item (click)="onDeleteSelected()" [disabled]="!dataSource.selection.hasValue()">
          <mat-icon>link_off</mat-icon> Unlink Selected
        </button>
      </mat-menu>

      <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect {{ utils.getLangTerm('contractors.singular', 'Contractor') }} {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}." style="min-width: 120px">
        <mat-icon>more_vert</mat-icon>
        List Menu
      </button>
    </span>

    <!--span class="spinner-container" *ngIf="dataSource.loading | async" appMarginRight>

      </span-->

    <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        aria-label="Search"/>

      <button
        mat-raised-button
        color="secondary"
        type="submit"
        class="mx-0 my-1">
        <mat-icon>search</mat-icon> Search
      </button>
    </form>

    <!--button mat-raised-button (click)="export()" color="secondary"><mat-icon>import_export</mat-icon> Export</button-->
  </nav>

  <div class="mat-elevation-z8 scroll-box">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null" [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()" [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? dataSource.selection.toggle(row.id) : null" [checked]="dataSource.selection.isSelected(row.id)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Site Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Site Address/Location Column -->
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Location</th>
        <td mat-cell *matCellDef="let element">{{ element.location }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="260"></th>
        <td mat-cell *matCellDef="let element">
          <button type="button" mat-button (click)="element.sssp ? onManageSSSP(element.sssp.sssp_hash) : onCreateSSSP(element.id)">
            {{ element.sssp ? 'Manage' : 'Create' }} {{ utils.getLangTerm('safety-plans.abbreviation', 'Safety Plan') }}
          </button>

          <button type="button" mat-button (click)="onRemove(element.site_id)">
            Unlink
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
